import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loginUser } from './actions';
import LoginForm from './LoginForm';
import { Redirect } from 'react-router-dom';
import { Grid, Row, Col, Breadcrumb } from 'react-bootstrap';
import LanguageMenu from '../languages/LanguageMenu';
import { withTranslation } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE } from './actions';

class Login extends React.Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.body.classList.add('login-background');
	}

	componentWillUnmount() {
		document.body.classList.remove('login-background');
	}

	render() {
		if (this.props.isAuthenticated) {
			const { from } = this.props.location.state || { from: { pathname: '/' } };
			return <Redirect to={from} />;
		}

		const { franchisor, t, languages } = this.props;
		const logoImg = franchisor && franchisor.logoUrl;

		return (
			<Grid fluid>
				<Row>
					<Col>
						<Breadcrumb className='login-breadcrumb'>
							{languages.length > 1 && <LanguageMenu languages={languages} />}
						</Breadcrumb>
					</Col>
				</Row>
				<Row className='body-simulate'>
					<div className='login example2'>
						<div className='main-login col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3'>
							{logoImg && <div className='logo'><img src={logoImg} /></div>}
							{!logoImg && <div className='logo'>{t('Login_Title', { systemName: franchisor && franchisor.systemName.toUpperCase() })}</div>}
							<ReduxBlockUi block={LOGIN_REQUEST} unblock={[LOGIN_SUCCESS, LOGIN_FAILURE]}>
								<div className='box-login'>
									<h3>{t('Login_Login')}</h3>
									<p>{t('Login_Text')}</p>
									<LoginForm onSubmit={this.props.loginUser} />
								</div>
							</ReduxBlockUi>
						</div>
					</div>
				</Row>
			</Grid>
		);
	}
}

Login.propTypes = {
	loginUser: PropTypes.func,
	location: PropTypes.object,
	isAuthenticated: PropTypes.bool,
	errors: PropTypes.array
};

const mapStateToProps = state => {
	const { configuration: { franchisor }, lookups: { languages } } = state;

	return {
		franchisor,
		languages,
		...state.auth
	};
};

export default connect(mapStateToProps, { loginUser })(withTranslation()(Login));